export const GOOGLE_MAPS_API_KEY = "AIzaSyCUAevtgJasc6M2mStQScTfvBgfDfvC2go";